import md5 from 'crypto-js/md5';
import { codeToText } from "element-china-area-data";

const TokenKey = 'zh-token'
const UserID = 'userId';

export function getUserInfo() {
    let userInfo = localStorage.getItem('userInfo');
    return userInfo ? JSON.parse(userInfo) : {};
}

export function getToken() {
    return localStorage.getItem(TokenKey);
}

export function setToken(token) {
    return localStorage.setItem(TokenKey, token);
}

export function removeToken() {
    return localStorage.removeItem(TokenKey);
}

export function getUserId() {
    return localStorage.getItem(UserID);
}
export function setUserId(id) {
    return localStorage.setItem(UserID, id);
}

export function getConfig() {
    let config = localStorage.getItem('publicConfig');
    return config ? JSON.parse(config) : null;
}

export function setConfig(config) {
    config = JSON.stringify(config);
    return localStorage.setItem('publicConfig',config);
}


//加密平台标识
const OS = 'web';

//加密盐
const SALT = 'emhhHaC';

//获取请求头
export const getHeader = () => {
    const timeStamp = Date.now() + '';
    const sign = '01' + md5(timeStamp + SALT);
    let obj = {
        'os': OS,
        'x-time': timeStamp,
        'x-sign': sign,
    };
    if (getToken()) {
        obj['token'] = getToken();
    }
    if (getUserId()) {
        obj['userId'] = getUserId();
    }
    return obj;
}

//把区域码转成汉字
export const getCodeToText = (codeArray) => {
    let area = [];
    switch (codeArray.length) {
        case 1:
            area.push(codeToText[codeArray[0]])
            break;
        case 2:
            area.push(codeToText[codeArray[0]])
            area.push(codeToText[codeArray[1]])
            break;
        case 3:
            area.push(codeToText[codeArray[0]])
            area.push(codeToText[codeArray[1]])
            area.push(codeToText[codeArray[2]])
            break;
        default:
            break;
    }
    return area;
}


//上传图片地址
export const uploadUrl = 'https://api.zhgylgl.com/api/uploadImg';

//获取公共数据列表
export const publicList = () => {
    let globalInfo = getConfig();
    if (!globalInfo) return {};
    let carLong, carType, goodsType, unit; //目前用到四个公共数据 车长 车型 货物类型 货物单位

    carType = globalInfo.carType;
    unit = globalInfo.unit;
    goodsType = globalInfo.goodsType.map(item => ({
        name: item,
        key: item
    }));
    carLong = globalInfo.carLong.map(item => ({
        name: item,
        key: item
    }));

    return {
        carLong,
        carType,
        goodsType,
        unit,
        validityPeriodTime: globalInfo.validityPeriodTime
    };
}



//深克隆方法
export const deepClone = (obj) => {
    let objClone = Array.isArray(obj) ? [] : {};
    if (obj && typeof obj === "object") {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                //判断ojb子元素是否为对象，如果是，递归复制
                if (obj[key] && typeof obj[key] === "object") {
                    objClone[key] = deepClone(obj[key]);
                } else {
                    //如果不是，简单复制
                    objClone[key] = obj[key];
                }
            }
        }
    }
    return objClone;
}

//返回一个秒为单位的时间戳 ,转换为2024/01/01 08:00:00
export function transformDate(time) {
    const timestamp = time;
    const date = new Date(timestamp * 1000);
    return date.toLocaleString();
}


//下载后端返回的文件
export const downloadFile = (url) => {
    var oReq = new XMLHttpRequest();
    // The Endpoint of your server
    const fileName = (url + '').replace('http://img.zhgylgl.com/', '');
    var URLToPDF = url;
    // Configure XMLHttpRequest
    oReq.open("GET", URLToPDF, true);
    // Important to use the blob response type
    oReq.responseType = "blob";
    // When the file request finishes
    // Is up to you, the configuration for error events etc.
    oReq.onload = function () {
        // Once the file is downloaded, open a new window with the PDF
        // Remember to allow the POP-UPS in your browser
        var file = new Blob([oReq.response], {
            type: "application/pdf"
        });
        // Generate file download directly in the browser !
        // saveAs(file, "mypdffilename.pdf");
        saveAs(file, decodeURIComponent(fileName));
    };
    oReq.send();
}

/**
 * 下载图片到本地
 * @param {string} imageUrl - 图片链接
 * @param {string} filename - 保存的文件名
 */
export const downloadImage = (imageUrl, filename = 'image.jpg') =>{
    // 创建一个隐藏的a标签用于下载
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = filename;
    link.style.display = 'none';
    
    // 将链接添加到页面并触发点击
    document.body.appendChild(link);
    link.click();
    
    // 清理DOM
    document.body.removeChild(link);
  }
  
  // 使用示例
  // downloadImage('https://example.com/image.jpg', 'my-image.jpg');


  export const setTMap = ()=>{
    console.log("引入腾讯地图");
    let script = document.createElement('script');
    script.src = 'https://map.qq.com/api/gljs?v=1.exp&key=H3FBZ-5MMKJ-HEDFW-D6NFK-46AZ6-LPBUE&libraries=geometry';
    document.documentElement.getElementsByTagName('head')[0].appendChild(script);
  }